export default {
      id: "volume-cookie-usage",
      viewBox: "0 0 45 33",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-cookie",
      toString: function () {
        return this.url;
      }
    }